import React from 'react'
import DataTree from './Tree'

export const Skate = () => (
   <>
      <DataTree />
   </>
)
